<script setup>
  import { computed, watch } from "vue";
  import { storeToRefs } from "pinia";
  import { useRouter } from "vue-router";
  import moment from "moment";

  import { useContractsStore } from "@stores/contracts";
  import { useCurrentUserStore } from "@stores/currentUser";

  import CreditsProgressBar from "@/components/Contracts/CreditsProgressBar.vue";

  const router = useRouter();
  const contractsStore = useContractsStore();
  const currentUserStore = useCurrentUserStore();

  const { nextToExpire } = storeToRefs(contractsStore);
  const { isClient } = storeToRefs(currentUserStore);

  watch(
    isClient,
    (value) => {
      if (value) contractsStore.fetchNextToExpire();
    },
    { immediate: true },
  );

  const featuredContract = computed(() => nextToExpire.value.contract);

  const expiresLabel = computed(() => {
    if (!featuredContract.value?.ends_at) return "";
    return `Expires ${moment(featuredContract.value.ends_at).format("D MMM YYYY")}`;
  });

  const goToContracts = () => router.push("/contracts");
</script>

<template>
  <div
    v-if="isClient"
    class="border-t border-b border-border px-3 py-3 cursor-pointer hover:bg-muted/30 transition-colors"
    @click="goToContracts">
    <div class="flex items-center justify-between mb-2">
      <p class="text-xs">Credits</p>
      <p
        v-if="featuredContract"
        class="text-xs">
        Contract {{ nextToExpire.position }} of {{ nextToExpire.active_count }}
      </p>
    </div>

    <template v-if="featuredContract">
      <CreditsProgressBar
        :consumed="featuredContract.credits_consumed_total"
        :total="featuredContract.total_credits"
        :show-unit="false"
        :compact="false" />
      <p class="text-xs mt-2">{{ expiresLabel }}</p>
    </template>

    <p
      v-else
      class="text-sm">
      No active contracts
    </p>
  </div>
</template>
